/* eslint-disable */
import React, { useContext } from 'react';
import { Data, Filters } from './contexts';
import { parseMoney } from '../utils';
import Highcharts from 'highcharts/highcharts.js';
import HighchartsReact from 'highcharts-react-official';

const RevenueAnalysis = (props) => {
    const { monthly_calcs } = useContext(Data);
    const { filters } = useContext(Filters);
    let finalFilters = props.tabFilters || filters;
    let filterYear = finalFilters.year
    const forecastYear = Object.keys(props.forecastVals || {}).length > 0 ? Object.keys(props.forecastVals['total_revenue'])[0] : null
    const monthsObj = {
        1: 'Jan',
        2: 'Feb',
        3: 'Mar',
        4: 'Apr',
        5: 'May',
        6: 'Jun',
        7: 'Jul',
        8: 'Aug',
        9: 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dec'
    }

    let revenue621Accounts = [
        {
            copy: 'Gross Charges',
            key: 'total_revenue_gross_charges',
        },
        {
            copy: 'Adjustments',
            key: 'total_revenue_adjustments',
        }
    ]

    const revenueDisplay = (month, year) => {
        let title = ''
        let paranthesisTitle = ''
        let endYear = String(year).slice(-2)
        let value = ''
        let displayDifference = false;
        let diffVal = ''
        let diffText1, diffText2 = ''
        let currentYearData = monthly_calcs?.you?.total_revenue?.[year]
        let prevYearData = monthly_calcs?.you?.total_revenue?.[year - 1]

        if (month === 'currentMonth') {
            displayDifference = true
            title = 'CURR. MONTH REVENUE'
            let totalRevenue = currentYearData ? Object.values(currentYearData) : []
            let currentMonth = totalRevenue && totalRevenue.indexOf(null) !== -1 ? totalRevenue.indexOf(null) : 12;
            if (currentMonth > 0) {
                paranthesisTitle = ` (${monthsObj[currentMonth]} ${endYear})`
                value = parseMoney(totalRevenue[currentMonth - 1])
                // ((Current Month Revenue - Last Month Revenue) / Last Month Revenue) * 100
                diffVal = ((totalRevenue[currentMonth - 1] - totalRevenue[currentMonth - 2]) / totalRevenue[currentMonth - 2]) * 100
                diffText1 = diffVal > 0 ? <span className='good-arrow'>&#9650; {diffVal.toFixed(2) + '%'}</span> : <span className='bad-arrow'>&#9660; {diffVal.toFixed(2) + '%'}</span>
                diffText2 = ' from last month'
            } else {
                paranthesisTitle = `(Dec ${endYear})`
            }
        }

        if (month === 'lastMonth') {
            title = 'LAST MONTH REVENUE'
            let totalRevenue = currentYearData ? Object.values(currentYearData) : []
            let currentMonth = totalRevenue && totalRevenue.indexOf(null) !== -1 ? totalRevenue.indexOf(null) : 12;
            if (currentMonth - 1 > 0) {
                paranthesisTitle = ` (${monthsObj[currentMonth - 1]} ${endYear})`
                value = parseMoney(totalRevenue[currentMonth - 2])
            }
        }

        if (month === 'ytd') {
            displayDifference = prevYearData ? true : false
            title = 'THIS YEAR TOTAL REVENUE'
            paranthesisTitle = `(${year} YTD)`
            let totalRevenue = currentYearData ? Object.values(currentYearData) : []
            let currentMonth = totalRevenue && totalRevenue.indexOf(null) !== -1 ? totalRevenue.indexOf(null) : 12;
            let ytd = currentYearData ? Object.values(currentYearData).reduce((a, b) => a + b, 0) : 0
            let previousYTD = prevYearData ? Object.values(prevYearData).slice(0, currentMonth).reduce((a, b) => a + b, 0) : 0

            diffVal = ((ytd - previousYTD) / previousYTD) * 100
            diffText1 = diffVal > 0 ? <span className='good-arrow'>&#9650; {diffVal.toFixed(2) + '%'}</span> : <span className='bad-arrow'>&#9660; {diffVal.toFixed(2) + '%'}</span>
            diffText2 = ' from last year (YTD)'
            value = parseMoney(ytd)
        }

        return (
            <div key={`${month}-revenue-analysis`} className='analysis-value-container'>
                <div className='analysis-value-title'><span className='analysis-value-first-title'>{title}</span><span className='analysis-value-second-title'>{paranthesisTitle}</span></div>
                <hr className='custom-report-line' />
                <span className='analysis-value'>{value}</span>
                {displayDifference ? <div className='difference-text'>{diffText1}<span>{diffText2}</span></div> : null}
            </div>
        )
    }

    const axisFormat = (format, num) => {
        switch (format) {
            case 'percent':
                return `${Highcharts.numberFormat((num * 100), 0, '', ',')}%`;
            case 'decimal':
                return Highcharts.numberFormat(num, 0);
            case 'ratio':
                return `${Highcharts.numberFormat(num, 0, '.', ',')}:1`;
            case 'money':
                if (Math.abs(num) >= 1000000) {
                    return num >= 0 ? `$${Highcharts.numberFormat(num / 1000000, 1)}M` : `-$${Highcharts.numberFormat(Math.abs(num / 1000000), 1)}M`;
                } else {
                    return num >= 0 ? `$${Highcharts.numberFormat(num / 1000, 0)}K` : `-$${Highcharts.numberFormat(Math.abs(num / 1000), 0)}K`;
                }
            case 'wholeNumber':
                return Math.round(num)
        }
    }

    const getPNLComboOptions = (youData = []) => {
        let endYear = String(filterYear).slice(-2)
        let xAxisCats = Object.values(monthsObj).map(m => `${m} ${endYear}`)

        return {
            accessibility: {
                description: 'P&L View'
            },
            title: {
                align: 'left',
                text: 'P&L View',
                style: {
                    color: '#525252'
                }
            },
            credits: {
            enabled: false
            },
            exporting: {
                enabled: false,
                allowHTML: true,
                chartOptions: {
                    plotOptions: {
                        series: {
                            dataLabels: {
                            enabled: true
                            }
                        }
                    }
                }
            },
          navigation: {
            menuItemHoverStyle: {
                background: '#f5f5f5',
                color: '#000000',
            },
            menuItemStyle: {
                padding: '3px 5px',
                fontWeight: 'bold'
            },
            menuStyle: {
                padding: '0',
            }
          },
          xAxis: {
            categories: xAxisCats,
            tickInterval: 2,
            startOnTick: true,
            crosshair: {}
          },
            yAxis: {
                min: null,
                title: {
                    enabled: false
                },
                gridLineWidth: 1,
                labels: {
                    formatter: function () {
                        if (this.value) {
                            return axisFormat('money', this.value)
                        } else {
                            return 0
                        }
                    },
                },
            },
            tooltip: {
                shared: true,
                formatter: function () {
                    if (!this.points || !this.x) return false;
                    let tooltipHtml = `<b>${this.x}</b><br/>`; // Add category (x-axis label)
                    this.points.forEach(point => {
                        let value = point.y >= 0 ? ` $${Highcharts.numberFormat(point.y, 0, '.', ',')}` : ` -$${Highcharts.numberFormat(Math.abs(point.y), 0, '.', ',')}`;
                        tooltipHtml += `
                        <span style="color:${point.color}">\u25CF</span> 
                        ${point.series.name}: <b>${value}</b><br/>
                        `;
                    });
                    return tooltipHtml;
                },
                style: { fontSize: '11px' },
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: 10,
                y: -10,
                floating: true,
                symbolRadius: 0,
            },
            plotOptions: {
                column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        return this.y >= 0 ? ` $${Highcharts.numberFormat(this.y, 0, '.', ',')}` : ` -$${Highcharts.numberFormat(Math.abs(this.y), 0, '.', ',')}`;
                    }
                },
                },
                spline: {
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            return this.y >= 0 ? ` $${Highcharts.numberFormat(this.y, 0, '.', ',')}` : ` -$${Highcharts.numberFormat(Math.abs(this.y), 0, '.', ',')}`;
                        },
                    },
                    lineWidth: 3,
                    marker: {
                        enabled: true, // Highlight spline points
                    },
                }
            },
            series: youData
        }
    }

    const pnlViewChart = () => {
        let youData = [];
        let pnlKeysData = {
          total_revenue: {
            copy: 'Revenue',
            color: '#69B144'
          },
          total_costs: {
            copy: 'COGS',
            color: '#999999'
          },
          total_people_costs: {
            copy: 'People',
            color: '#00AEEF'
          },
          total_customer_costs: {
            copy: 'Customer',
            color: '#542667'
          },
          'total_operating_expenses_general_& administrative': {
            copy: 'General & Administrative',
            color: '#00AEEF',
          },
          'total_operating_expenses_product_development': {
            copy: 'Product',
            color: '#542667',
          },
          'total_operating_expenses_sales': {
            copy: 'Sales',
            color: '#D90000',
          },
          'total_operating_expenses_marketing': {
            copy: 'Marketing',
            color: '#BA68C8',
          },
          total_operations: {
            copy: 'OpEx',
            color: '#69B144'
          },
          total_other_costs: {
            copy: 'Other Expenses',
            color: '#FFB74D'
          },
        }

        let pnlKeys = Object.keys(pnlKeysData)

        pnlKeys.forEach((key) => {
            let data = []
            let total = 0

            if (monthly_calcs?.you?.[key]?.[filterYear]) {
                data = Object.values(monthly_calcs?.you?.[key]?.[filterYear])
            }

          total = data.reduce((a, b) => a + b, 0)

          if (key === 'total_revenue') {
            youData.push({
              color: pnlKeysData[key].color,
              name: pnlKeysData[key].copy,
              type: 'spline',
              data: data,
              zIndex: 10,
            })
          } else {
            if (total !== 0) {
              youData.push({
                color: pnlKeysData[key].color,
                name: pnlKeysData[key].copy,
                type: 'column',
                data: data,
                zIndex: 1,
              })
            }
          }
        })

        return getPNLComboOptions(youData);
    }

    const valsCummulativeByMonth = (monthlyRevenue = []) => {
        let revenueValues = []
        let revenueTotal = 0
        for (let i = 0; i < monthlyRevenue.length; i++) {
            revenueTotal += monthlyRevenue[i]
            revenueValues.push(revenueTotal)
        }
        return revenueValues
    }

    const totalRevenueAreaChartOptions = (metric) => {
        let endYear = String(filterYear).slice(-2)
        let xAxisCats = Object.values(monthsObj).map(m => `${m} ${endYear}`)
        let totalRevenue = monthly_calcs?.you?.[metric]?.[filterYear] ? Object.values(monthly_calcs?.you?.[metric]?.[filterYear]) : []
        let revenueCummulative = valsCummulativeByMonth(totalRevenue)
        let finalTitle = metric === 'total_revenue' ? 'Total Revenue This Year (Cummulative)' : 'Total Expenses This Year'
        let lengendLabel = metric === 'total_revenue' ? 'Total Revenue' : 'Total Expenses'
        let lineColor = metric === 'total_revenue' ? '#69B144' : '#e46b50'
        let areaColor = metric === 'total_revenue' ? '#d7e5ce' : '#fbddcc'

        return {
            chart: {
                type: 'area'
            },
            accessibility: {
                description: finalTitle
            },
            title: {
                align: 'left',
                text: finalTitle,
                style: {
                    color: '#525252'
                }
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: -10,
                y: 0,
                floating: true,
                symbolRadius: 0
            },
            credits: {
                enabled: false
            },
            navigation: {
                buttonOptions: {
                    enabled: false
                }
            },
            xAxis: {
                categories: xAxisCats,
                gridLineDashStyle: 'ShortDot',
                gridLineWidth: 1,
                startOnTick: true,
                tickPosition: 'inside',
                tickInterval: 2,
                tickLength: 5,
                tickWidth: 1,
            },
            yAxis: {
                title: {
                    text: null
                },
                gridLineWidth: 1,
                labels: {
                    formatter: function () {
                        if (this.value) {
                            return axisFormat('money', this.value)
                        } else {
                            return 0
                        }
                    },
                },
            },
            tooltip: {
                enabled: props.pdf ? false : true,
                style: {
                    stroke: "none",
                },
                useHTML: true,
                formatter: function () {
                    return this.y >= 0 ? ` $${Highcharts.numberFormat(this.y, 0, '.', ',')}` : ` -$${Highcharts.numberFormat(Math.abs(this.y), 0, '.', ',')}`;
                }
            },
            plotOptions: {
                area: {
                    fillColor: areaColor,
                    marker: {
                        enabled: true,
                        fillColor: '#FFFFFF',
                        lineWidth: 1,
                        radius: 2,
                        lineColor: null,
                        states: {
                            hover: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            series: [{
                color: lineColor,
                name: lengendLabel,
                data: revenueCummulative
            }]
        };
    }

    const totalRevenueLineChartOptions = (metric) => {
        let endYear = String(filterYear).slice(-2)
        let xAxisCats = Object.values(monthsObj).map(m => `${m} ${endYear}`)
        let firstSeries = monthly_calcs?.you?.[metric]?.[filterYear] ? Object.values(monthly_calcs?.you?.[metric]?.[filterYear]) : []
        let secondSeries = monthly_calcs?.you?.[metric]?.[filterYear - 1] ? Object.values(monthly_calcs?.you?.[metric]?.[filterYear - 1]) : []
        let peersSeries = props.aggregateData && props.aggregateData?.monthly?.avg?.[metric]?.[filterYear] ? Object.values(props.aggregateData?.monthly?.avg?.[metric]?.[filterYear]) : []
        let forecastSeries = props.forecastVals && props.forecastVals?.[metric]?.[forecastYear] ? Object.values(props.forecastVals?.[metric]?.[forecastYear]) : []
        let firstSeriesName = metric === 'total_revenue' ? 'Revenue' : 'Expenses'
        let lineColor = metric === 'total_revenue' ? '#69B144' : '#737373'
        let tooltipOrder = [firstSeriesName, 'Last Year', 'Peers', props.forecastName]
        let chartData = [
            {
                color: '#999999',
                name: 'Last Year',
                data: secondSeries,
                type: 'line',
                dashStyle: 'LongDash',
                legendSymbol: 'rectangle',
                legendIndex: 1
            },
            {
                color: lineColor,
                name: firstSeriesName,
                data: firstSeries,
                type: 'line',
                legendSymbol: 'rectangle',
                legendIndex: 0
            },
        ]

        if (peersSeries.length > 0) {
            chartData.unshift(
                {
                    color: '#d3d3d3',
                    name: 'Peers',
                    data: peersSeries,
                    type: 'line',
                    legendSymbol: 'rectangle',
                    legendIndex: 2
                }
            )
        }

        if (forecastSeries.length > 0) {
            chartData.unshift(
                {
                    color: '#f17b5b',
                    name: props.forecastName,
                    data: forecastSeries,
                    type: 'line',
                    legendSymbol: 'rectangle',
                    legendIndex: 3
                }
            )
        }

        return {
            accessibility: {
                description: 'This year expenses vs last year expenses vs peers expenses vs forecast expenses'
            },
            title: {
                align: 'left',
                text: 'YOY vs Peers vs Forecast',
                style: {
                    color: '#525252'
                }
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: -10,
                y: 8,
                floating: true,
                symbolRadius: 0,
            },
            credits: {
                enabled: false
            },
            navigation: {
                buttonOptions: {
                    enabled: false
                }
            },
            xAxis: {
                categories: xAxisCats,
                gridLineDashStyle: 'ShortDot',
                gridLineWidth: 1,
                startOnTick: true,
                tickPosition: 'inside',
                tickInterval: 2,
                tickLength: 5,
                tickWidth: 1,
            },
            yAxis: {
                title: {
                    text: null
                },
                gridLineWidth: 1,
                labels: {
                    formatter: function () {
                        if (this.value) {
                            return axisFormat('money', this.value)
                        } else {
                            return 0
                        }
                    },
                },
            },
           tooltip: {
                enabled: props.pdf ? false : true,
                shared: true,
                style: {
                    stroke: "none",
                },
                useHTML: true,
                formatter: function () {
                    if (!this.points || !this.x) return false;
                    const points = this.points.slice().sort((a, b) => {
                            return tooltipOrder.indexOf(a.series.name) - tooltipOrder.indexOf(b.series.name);
                        });

                    let s = `<b>${this.x}</b><br/>`;
                    points.forEach(point => {
                        let pointVal = point.y >= 0 ? ` $${Highcharts.numberFormat(point.y, 0, '.', ',')}` : ` -$${Highcharts.numberFormat(Math.abs(point.y), 0, '.', ',')}`;
                        s += `<span style="color:${point.series.color}">\u25CF</span> ${point.series.name}: <b>${pointVal}</b><br/>`;
                    });
                    return s;
                }
            },
            plotOptions: {
                line: {
                    marker: {
                        enabled: true,
                        fillColor: '#FFFFFF',
                        lineWidth: 1,
                        radius: 2,
                        lineColor: null,
                        states: {
                            hover: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            series: chartData
        };
    }

    const revenueTop10Chart = () => {
        let totalRevenue = monthly_calcs?.you?.total_revenue?.[filterYear] ? Object.values(monthly_calcs?.you?.total_revenue?.[filterYear]) : []
        let currentMonth = totalRevenue && totalRevenue.indexOf(null) !== -1 ? totalRevenue.indexOf(null) : 12;
        let revenue621Keys = props.naicsCode.startsWith('621') ? revenue621Accounts : null;
        let finalRev = []
        if (revenue621Keys) {
            revenue621Keys = revenue621Keys.map((r, i) => {
                r.value = monthly_calcs?.you?.[r.key]?.[filterYear]?.[currentMonth]
                return r
            })
        }
        let sortedRev = revenue621Keys ? revenue621Keys.sort((a, b) => b.value - a.value) : []
        finalRev = sortedRev.map(t => {
            let topRev = sortedRev[0]
            t.percent = (t.value / topRev.value) * 100
            return t
        })

        return (
            <div key='revenue-top10-chart' className='top10-chart-container'>
                <div className='analysis-chart-title'>Revenue Mix - Top 10 Accounts</div>
                {
                    !revenue621Keys && (<div className='top10-chart-item'>
                        <div className='top10-details'><span>Total Revenue</span> <span>{parseMoney(totalRevenue[currentMonth - 1])}</span></div>
                        <div className='top10-green-background'></div>
                    </div>)
                }
                {
                    revenue621Keys && (finalRev.map(r => {
                        let barStyle = { 'width': r.percent + '%' }
                        return (
                            <div className='top10-chart-item'>
                                <div className='top10-details'><span>{r.copy}</span> <span>{parseMoney(r.value)}</span></div>
                                <div className='top10-green-background' style={barStyle}></div>
                            </div>
                        )
                    }))
                }
            </div>
        )
    }

    return (
        <div className={`money-content`}>
            {monthly_calcs ?
                (<div className='custom-report-pdf-portrait'>
                    <div key='revenue-analysis-title'>
                        <h1 className='analysis-page-title'>{props.tabName}</h1>
                        <hr className='custom-report-line' />
                    </div>
                    <div key='revenue-analysis-values' className='analysis-values'>
                        {revenueDisplay('currentMonth', filterYear)}
                        {revenueDisplay('lastMonth', filterYear)}
                        {revenueDisplay('ytd', filterYear)}
                    </div>
                    <div key='revenue-analysis-charts' className='analysis-page-charts'>
                        {revenueTop10Chart()}
                        <div key='rev-pnl-view'>
                            <HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: '370px', minHeight: '370px' } }} options={pnlViewChart()} />
                        </div>
                        <div key='rev-cummulative'>
                            <HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: '370px', minHeight: '370px' } }} options={totalRevenueAreaChartOptions('total_revenue')} />
                        </div>
                        <div key='rev-compare'>
                            <HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: '370px', minHeight: '370px' } }} options={totalRevenueLineChartOptions('total_revenue')} />
                        </div>
                    </div>
                </div>)
                : (<div className='custom-report-pdf-portrait'>
                    <div>You must have Monthly data available to view this page.</div>
                </div>)
            }
        </div >
    )
}

export default RevenueAnalysis;